import { render, staticRenderFns } from "./DiapersSize.vue?vue&type=template&id=033de2a5&scoped=true"
import script from "./DiapersSize.vue?vue&type=script&lang=js"
export * from "./DiapersSize.vue?vue&type=script&lang=js"
import style0 from "./DiapersSize.vue?vue&type=style&index=0&id=033de2a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033de2a5",
  null
  
)

export default component.exports